<template>
  <div class="seomain part-search">
    <st-header
      title="服务器配置清单"
      :back-able="true"
    >
    </st-header>

    <div class="service">
      <div class="service-svg">
        <img src="@/assets/svg/server.svg" alt="" style="max-width: 26px;position: relative; top: 50%;transform: translateY(-50%);">
        <!-- <van-icon name="desktop-o" /> -->
      </div>
      <div class="service-name">
        {{ server_sn }}
      </div>
    </div>
    <div class="service-table" v-loading="loading">
      <table style="width: 100%;">
        <tbody class="service-tbody" v-if="tableData.length > 0">
          <tr v-for="(row, ri) in tableData" :key="ri">
          <td>
            <div style="width: 71px;">{{ row.cate }}</div>
          </td>
          <td>
            <div style="text-align: left;overflow-wrap: break-word;">{{ row.sku }}</div>
          </td>
          <td>
            <div style="width: 74px;">{{ row.count }} PCS</div>
          </td>
        </tr>
        </tbody>
        <tbody v-else style="line-height: 80px;">暂无数据</tbody>
      </table>
    </div>

    <div style="margin: 16px;" class="form-submit-button">
      <van-button round block type="primary" @click="repair" v-if="ordercode" v-loading="submiting">
        在线报修
      </van-button>
    </div>
  </div>
</template>

<script>
import StHeader from "@/components/layout/Header.vue";
export default {
  components: {
    "st-header": StHeader,
  },

  props: {},
  data() {
    return {
      tableData: [],
      server_sn: '',
      ordercode: '',
      submiting: false,
    };
  },
  watch: {},

  methods: {
    init() {
      this.getData()
    },
    getData() {
      this.loading = true;
      // 测试域名http://www.mest_toasin.test/check/index/serverSnPartSearch
      // let url = "http://www.mest_toasin.test/check/index/serverSnPartSearch";
      let url = "https://mes.toasin.cn/check/index/serverSnPartSearch";
      this.$post(url, { server_sn: this.$route.params.id }).then((res) => {
        if (res.code === 1) {
          if (res['data']) {
            console.log('debugrd', res['data']);
            this.tableData = res['data']['parts']
            this.server_sn = res['data'].server_sn;
            this.ordercode = res['data'].order_code;
          } else {
            this.tableData = [];
          }
          
        } else {
          this.$toast.fail(res.msg);
        }
        this.loading = false;
      });

      // if (res.code === 1) {
      //   this.tableData = res['data']['parts']
      //   this.server_sn = res['data'].server_sn;
      // } else {
      //   this.$toast.fail(res.msg);
      // }
    },
    // 获取工单
    async getOrderList(type) {
      let res = await this.$post(this.$api.stRmaOrderSelect, {
        mes_order_code: this.ordercode,
        type: type
      }).catch((e) => {
        console.log(e);
      })
      return res;
    },
    // 报修
    repair() {
      if (!this.ordercode) {
        console.log('debugrdoo', this.ordercode);
        this.$toast.fail('该服务器没有销售单号，无法进行报修');
        return;
      }
      this.submiting = true;
      // this.$router.push(`/saleRep/order/all/${this.ordercode}`);
      this.getOrderList('all').then((res) => {
        if (res['data'].length <= 0) {
          this.$router.push('/saleRep/submit/' + this.ordercode);
        } else {
          this.$router.push(`/saleRep/order/all/${this.ordercode}`);
        }
        this.submiting = false;
      }).catch((e) => {
        this.$toast.fail(e);
      });
    },
    cancel() {

    },
    confirm() {

    },
  },
  created() {
    this.init();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.part-search::after {
  content: '';
  background-image: url('~@/assets/images/warter.png');
  background-size: 60%; 
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.1;
  position: absolute;
  
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: -1;
}

.form-submit-button {
  padding-left: 12px;
  padding-right: 12px;
}

.van-button--round {
  border-radius: 5px;
  background-color: #1989fa;
  border: none;
}

.part-search {
  z-index: 0;
  position: relative;

  /deep/ .st-header {
    height: 60px;

    .st-header-content {
      height: 60px;
      font-size: 14px;
      color: rgba(80, 80, 80, 1);
      background-color: rgba(229, 229, 229, 1);
      position: relative;
    }

    .st-header-left {
      left: 28px;
    }

    .st-header-left, .st-header-center, .st-header-right {
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .service {
    display: flex;
    padding: 9px 18px;
    min-height: 20px;

    .van-icon-desktop-o {
      font-size: 48px;
    }

    .service-name {
      width: 151px;
      height: 27px;
      color: rgba(0, 0, 0, 1);
      font-size: 18px;
      padding: 12px 11px;
      line-height: 150%;
      text-align: left;
      font-weight: bold;
    }
  }
  
  .service-table {
    border-collapse: collapse;
    border: none;
    
    text-align: center;
    padding-left: 26px;
    padding-right: 26px;
    

    table {
      min-height: 80px;
      background-color: rgba(255, 255, 255, 0.8);
      border-radius: 5px;
    }

    th, td {
        border: none;
    }

    td div {
      padding: 14px 0px 15px;
    }
  }
  .service-tbody {
    border-radius: 5px;
  }
}


</style>

